// extracted by mini-css-extract-plugin
export default {"Avatar":"Login_Avatar__Xx+C-","Paper":"Login_Paper__npE8C","Form":"Login_Form__j9ysv","Submit":"Login_Submit__NUXQX","Logo":"Login_Logo__19jyF"};